// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./casino_table"

// Mobile menu toggle
document.addEventListener('turbo:load', () => {
  const mobileMenuButton = document.getElementById('mobile-menu-button');
  const mobileMenu = document.getElementById('mobile-menu');
  
  if (mobileMenuButton && mobileMenu) {
    mobileMenuButton.addEventListener('click', () => {
      mobileMenu.classList.toggle('hidden');
    });
  }
});
